
export enum GeneralStatusEnum {
    Active = "ACTIVE",
    Suspended = "SUSPENDED",
    Deleted = "DELETED",
}
